import AsyncStorage from '@react-native-community/async-storage';

const userToken = 'userToken';
const socketSession = 'socketSession';
const socketSessionExpiration = 'socketSessionExpiration';
const socketChannel = 'socketChannel';

const saveToken = async (token: string, id: any) => {
  await AsyncStorage.setItem(userToken, JSON.stringify({ token, id }));
};

const getToken = async (): Promise<{ token: string; id: any }> => {
  const result = await AsyncStorage.getItem(userToken);
  if (result) {
    const { token, id } = JSON.parse(result);

    return { token, id };
  }
  return { token: '', id: '' };
};

const clearToken = async () => {
  await AsyncStorage.removeItem(userToken);
};

const saveSocketToken = async (token: string, expiresIn: string) => {
  await AsyncStorage.setItem(socketSession, token);
  await AsyncStorage.setItem(socketSessionExpiration, expiresIn);
};

const getSocketToken = async (): Promise<string | null> => {
  const token = await AsyncStorage.getItem(socketSession);
  return token;
};

const getSocketTokenExpiration = async (): Promise<string | null> => {
  const expiresIn = await AsyncStorage.getItem(socketSessionExpiration);
  return expiresIn;
};

const clearSocketToken = async () => {
  await AsyncStorage.removeItem(socketSession);
  await AsyncStorage.removeItem(socketSessionExpiration);
};

const saveSocketChannel = async ({
  departChannel,
  departSeatsLabel,
  returnChannel = '',
  returnSeatsLabel,
}: {
  departChannel: string;
  departSeatsLabel: string[];
  returnChannel?: string;
  returnSeatsLabel?: string[];
}) => {
  await clearSocketChannel();
  await AsyncStorage.setItem(
    socketChannel,
    JSON.stringify({ departSeatsLabel, returnSeatsLabel, departChannel, returnChannel }),
  );
};

const clearSocketChannel = async () => {
  await AsyncStorage.removeItem(socketChannel);
};

const getSocketChannel = async () => {
  const socketData = await AsyncStorage.getItem(socketChannel);
  if (socketData) {
    const { departChannel, returnChannel, departSeatsLabel, returnSeatsLabel } = JSON.parse(socketData);
    return { departChannel, returnChannel, departSeatsLabel, returnSeatsLabel };
  }
  return null;
};

const clearAllData = () => {
  console.log('CLEAR ALL DATA');
  clearToken();
  clearSocketToken();
  clearSocketChannel();
};

export default {
  saveToken,
  getToken,
  clearToken,

  saveSocketToken,
  getSocketToken,
  getSocketTokenExpiration,
  clearSocketToken,
  saveSocketChannel,
  getSocketChannel,
  clearSocketChannel,
  clearAllData,
};
